import { useTranslation } from 'react-i18next';
import { Avatar, AvatarFallback } from '@/shared/components/ui/avatar';
import { formatTimeAgo } from '@/shared/utils/formatTimeAgo';
import { getInitials } from '@/core/lib/get-initials';
import { buildActivityMessage } from '../../utils/activity-message';
import type { ActivityDto } from '../../types';

interface ActivityLogItemProps {
  activity: ActivityDto;
}

export function ActivityLogItem({ activity }: ActivityLogItemProps) {
  const { t } = useTranslation('tasks');

  const actorName = activity.actorName ?? '';
  const { actionText, detail } = buildActivityMessage(activity, t);

  return (
    <div className="flex gap-2.5 py-2.5" data-testid="tasks-activity-item">
      <Avatar className="mt-0.5 h-6 w-6 shrink-0">
        <AvatarFallback className="text-[9px]">{getInitials(actorName)}</AvatarFallback>
      </Avatar>

      <div className="min-w-0 flex-1">
        <p className="text-xs leading-snug text-foreground">
          <span className="font-medium">{actorName}</span>{' '}
          <span className="text-muted-foreground">{actionText}</span>
        </p>

        {detail != null && <p className="mt-0.5 text-xs text-muted-foreground">{detail}</p>}

        <p className="mt-0.5 text-[10px] text-muted-foreground/70">
          {formatTimeAgo(activity.createdAt)}
        </p>
      </div>
    </div>
  );
}
